module.exports = __webpack_public_path__ + "static/media/portal-showcase-poster.87455218.png";